module.exports = __webpack_public_path__ + "img/globish-space-logo.b3fe393b.svg";